var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{directives:[{name:"waves",rawName:"v-waves"}],staticClass:"button rounded flex justify-center items-center text-sm"},[_vm._t("default",function(){return [(_vm.icon)?_c('ion-icon',{staticClass:"w-5 h-5",attrs:{"icon":_vm.icon}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }